import TiptapHeading from '@tiptap/extension-heading';

export const Heading = TiptapHeading.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      levels: [1, 2, 3, 4] as const,
      HTMLAttributes: {
        ...(this.parent?.().HTMLAttributes ?? {}),
      },
    };
  },

  renderHTML({ node, HTMLAttributes }) {
    const level = node.attrs.level as number;
    const tag = `h${level}` as 'h1' | 'h2' | 'h3' | 'h4';
    const levelClass = `editor-heading editor-heading-${level}`;

    const parentClass = this.options.HTMLAttributes?.class ?? '';
    const extraClass = HTMLAttributes?.class ?? '';
    const mergedClass = [levelClass, parentClass, extraClass]
      .filter(Boolean)
      .join(' ');

    return [
      tag,
      { ...this.options.HTMLAttributes, ...HTMLAttributes, class: mergedClass },
      0,
    ];
  },
});
